<template>
    <div :class="{'form-group': true, 'base-input':true, 'has-feedback': this.icon, 'has-error': this.errors}">
        <label class="control-label" :for="id" :style="labelStyle">{{label}}</label>
        <input v-if="type !== 'textarea'" :type="type"
               class="form-control"
               :id="id"
               :name="id"
               :value="value"
               :placeholder="placeholder"
               :style="inputStyle"
               @input="input"
               v-on="listeners"/>
        <textarea class="form-control"
                  :id="id"
                  :name="id"
                  :value="value"
                  :placeholder="placeholder"
                  :style="inputStyle"
                  @input="input"
                  v-on="listeners"
                  v-else></textarea>
        <font-awesome-icon :icon="icon" class="form-control-feedback" v-if="icon"></font-awesome-icon>
        <div v-if="this.errors" class="text-danger invalid-feedback">
            <span class="block" v-for="err in errors">{{err}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BaseInput",
        props: ['id', 'label', 'type', 'value', 'icon' ,'errors', 'placeholder', 'labelStyle', 'inputStyle'],
        methods: {
            input(event) {
                let newVal = event.target.value;
                this.$emit('input', newVal);
            },
        },
        computed: {
            // Setup transparent wrapper component implementation
            listeners() {
                let listeners = Object.assign({}, this.$listeners);
                delete listeners.input;
                return listeners;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .base-input {
        .control-label{
            color: #595e63;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 500;
        }
        .form-group {
            position: relative;
            margin-right: 0;
            margin-left: 0;
        }
        .form-control{
            font-family: Poppins;
            font-size: 12px;
        }
        textarea {
            height: 5rem;
        }
        .form-control-feedback{
            font-size: 14px;
            right: 15px;
            z-index: 3;
            color: var(--input-text-color);
        }
        input, textarea {
            background-color: var(--input-background-color);
            color: var(--input-text-color);
            border-color: var(--input-border-color);
        }
    }
</style>